import { Expose } from "class-transformer";

export class CreatePayrollLineDto {
  @Expose()
  conceptKey: string;

  @Expose()
  label: string;

  @Expose()
  quantity: number;

  @Expose()
  quantityScale: number;

  @Expose()
  quantityUnit?: string;

  @Expose()
  unitPrice: number;

  @Expose()
  position?: number;
}
